import React from 'react';

import { usePage } from '@brz-utils/contexts/page.context';
import { SEO } from '@brz-utils/seo/seo';
import { useSiteSettings } from '@brz-utils/use.site.settings';
import { TinaMarkdown } from 'tinacms/dist/rich-text';
import { toTinaMarkdown } from '@brz-utils/toTinaMarkdown';
import { RichCurrentYear } from '@brz-components/elements/rich.current.year';

export const Head = () => {
    const { page } = usePage();
    const site = useSiteSettings();

    // const [className, setClassName] = React.useState('wf-inactive');

    // React.useEffect(() => {
    //     setInterval(() => {
    //         setClassName((prev) => {
    //             return prev ? '' : 'wf-inactive'
    //         })
    //     }, 1000);
    // }, [])
    
    return <>
        {/* <html className={className} /> */}

        {page.seo?.title ? (
            <title>
                <TinaMarkdown 
                    content={toTinaMarkdown(page.seo.title)} 
                    components={{
                        'CurrentYear': RichCurrentYear
                    }}
                />
                {` | ${site.name}`}
            </title>
        ) : null}
        
        {page.seo?.description ? (
            <meta name="description" content={page.seo.description} />
        ) : null}
        <meta name="viewport" content="initial-scale=1, width=device-width" />

        {/* Web Manifest */}
        <link rel="manifest" href="/.webmanifest" crossOrigin="use-credentials" />
        {/* Favicon */}
        <link rel="icon" type="image/png" href="/favicons/16x16.png" />
        {/* Sitemap */}
        <link rel="sitemap" type="application/xml" title="Sitemap" href="/sitemap-index.xml" />

        <SEO />
    </>
};